import { Button, Col, Modal, Row } from 'antd'
import Logo from '../../images/logo.svg'
import PowerLogo from '../../images/powered_by_sofihub_adt.svg'
import moment from 'moment'

const About = props => {
    return (
        <Modal
            title="About"
            open={props.open}
            onCancel={props.onClose}
            footer={null}
        >
            <Row>
                <Col span={24}>
                    <div className="about_img">
                        <Logo width={230} height={120}/>
                    </div>
                    <div className="versions">
                        <ul>
                            <li>Portal Version: {process.env.APP_VERSION}</li>
                            <li>API Version: {props.apiVersion}</li>
                        </ul>
                    </div>
                </Col>
            </Row>
            <hr />
            <Row type="flex" justify="space-between" align="middle">
                <Col><PowerLogo width={160} height={40}/></Col>
                <Col span={12} className="copy_right">
                    <span>Copyright ©Sofihub {moment().year()}</span>
                </Col>
                <Col className="footer_btn">
                    <Button key="back" onClick={props.onClose}>Close</Button>
                </Col>
            </Row>
        </Modal>
    )
}


export default About
